import { JSX } from "react";
import { motion } from "framer-motion";

const styles = {
  section: "mx-auto max-w-7xl px-6 py-10 my-8",
  header: "mx-auto max-w-3xl lg:text-center",
  h2: "text-base font-semibold leading-7 text-green-600",
  title: "mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl",
  desc: "mt-6 text-lg leading-8 text-gray-600",
  contentWrap: "mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-4xl",
  textCenter: "text-center",
  h3: "text-xl font-semibold text-gray-900",
  p: "mt-4 text-lg leading-7 text-gray-600",
  pBold: "mt-4 text-lg leading-7 text-gray-600 font-semibold",
};

const headerVariants = {
  hidden: { opacity: 0, y: 40 },
  show: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", stiffness: 60, delay: 0.1 },
  },
};
const titleVariants = {
  hidden: { opacity: 0, y: 30 },
  show: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", stiffness: 60, delay: 0.2 },
  },
};
const descVariants = {
  hidden: { opacity: 0, y: 20 },
  show: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", stiffness: 60, delay: 0.3 },
  },
};
const contentVariants = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.18, delayChildren: 0.4 },
  },
};
const itemVariants = {
  hidden: { opacity: 0, scale: 0.92, y: 30 },
  show: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: { type: "spring", stiffness: 80 },
  },
};

const MissionSection = (): JSX.Element => {
  return (
    <div className={styles.section}>
      <motion.div
        className={styles.header}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.7 }}
        variants={headerVariants}
      >
        <motion.p className={styles.h2} variants={headerVariants}>
          Nuestra Misión
        </motion.p>
        <motion.h2 className={styles.title} variants={titleVariants}>
          Impulsar la salud y bienestar de las mascotas a través de tecnología
        </motion.h2>
        <motion.p className={styles.desc} variants={descVariants}>
          En AppCotas, estamos comprometidos con mejorar el cuidado de los
          animales mediante una plataforma digital accesible no solo para
          veterinarios y profesionales de la salud animal, sino también para
          todos aquellos que deseen aportar al bienestar de los animales.
          Sabemos que tu tiempo es valioso, por lo que nos enfocamos en
          facilitar cada aspecto de la gestión veterinaria, brindándote
          herramientas diseñadas para optimizar y agilizar tus tareas diarias.
        </motion.p>
      </motion.div>

      <motion.div
        className={styles.contentWrap}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.5 }}
        variants={contentVariants}
      >
        <div className={styles.textCenter}>
          <motion.h3
            className={styles.h3}
            variants={itemVariants}
            whileHover={{
              scale: 1.06,
              color: "#22c55e",
              textShadow: "0 2px 16px #bbf7d0",
              transition: { type: "spring", stiffness: 200, damping: 12 },
            }}
          >
            ¡Transforma la atención a tus pacientes!
          </motion.h3>
          <motion.p className={styles.p} variants={itemVariants}>
            Mejorar la calidad de vida de tus pacientes nunca fue tan fácil. Con
            AppCotas, puedes acceder a una plataforma todo en uno que optimiza
            la gestión de citas, tratamientos y recordatorios, asegurando que
            los cuidados de tus pacientes estén siempre al día.
          </motion.p>
          <motion.p
            className={styles.pBold}
            variants={itemVariants}
            whileHover={{
              scale: 1.04,
              color: "#15803d",
              textShadow: "0 2px 16px #bbf7d0",
              transition: { type: "spring", stiffness: 200, damping: 12 },
            }}
          >
            Únete a la revolución digital en el cuidado de la salud animal y
            lleva tu práctica al siguiente nivel con AppCotas.
          </motion.p>
        </div>
      </motion.div>
    </div>
  );
};
export default MissionSection;
